const GET_USER_ACCOUNT = 'usuarios/account/GET_USER_ACCOUNT';
const GET_USER_ACCOUNT_COMPLETED = 'usuarios/account/GET_USER_ACCOUNT_COMPLETED';
const GET_USER_ACCOUNT_FAILED = 'usuarios/account/GET_USER_ACCOUNT_FAILED';

const PUT_USER_ACCOUNT = 'usuarios/account/PUT_USER_ACCOUNT';
const PUT_USER_ACCOUNT_COMPLETED = 'usuarios/account/PUT_USER_ACCOUNT_COMPLETED';
const PUT_USER_ACCOUNT_FAILED = 'usuarios/account/PUT_USER_ACCOUNT_FAILED';

const PATCH_USER_ACCOUNT = 'usuarios/account/PATCH_USER_ACCOUNT';
const PATCH_USER_ACCOUNT_COMPLETED = 'usuarios/account/PATCH_USER_ACCOUNT_COMPLETED';
const PATCH_USER_ACCOUNT_FAILED = 'usuarios/account/PATCH_USER_ACCOUNT_FAILED';

const POST_USER_ACCOUNT = 'usuarios/account/POST_USER_ACCOUNT';
const POST_USER_ACCOUNT_COMPLETED = 'usuarios/account/POST_USER_ACCOUNT_COMPLETED';
const POST_USER_ACCOUNT_FAILED = 'usuarios/account/POST_USER_ACCOUNT_FAILED';

const DELETE_USER_ACCOUNT = 'usuarios/account/DELETE_USER_ACCOUNT';
const DELETE_USER_ACCOUNT_COMPLETED = 'usuarios/account/DELETE_USER_ACCOUNT_COMPLETED';
const DELETE_USER_ACCOUNT_FAILED = 'usuarios/account/DELETE_USER_ACCOUNT_FAILED';

const RESET_USER_ACCOUNT = 'usuarios/account/RESET_USER_ACCOUNT';

export {
  GET_USER_ACCOUNT,
  GET_USER_ACCOUNT_COMPLETED,
  GET_USER_ACCOUNT_FAILED,
  PUT_USER_ACCOUNT,
  PUT_USER_ACCOUNT_COMPLETED,
  PUT_USER_ACCOUNT_FAILED,
  PATCH_USER_ACCOUNT,
  PATCH_USER_ACCOUNT_COMPLETED,
  PATCH_USER_ACCOUNT_FAILED,
  POST_USER_ACCOUNT,
  POST_USER_ACCOUNT_COMPLETED,
  POST_USER_ACCOUNT_FAILED,
  RESET_USER_ACCOUNT,
  DELETE_USER_ACCOUNT,
  DELETE_USER_ACCOUNT_COMPLETED,
  DELETE_USER_ACCOUNT_FAILED
};
